import React, { useState } from "react";
import '../styles/buscador.css';

const Buscador = ({ onBuscar }) => {
  const [termino, setTermino] = useState('');

  const handleBuscar = () => {
    if (termino.trim() !== '') {
      onBuscar(termino);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBuscar();
    }
  };

  return (
    <div className="buscador">
      <input
        type="text"
        placeholder="¿Dónde está Totto?"
        value={termino}
        onChange={(e) => setTermino(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <button onClick={handleBuscar}>Buscar</button>
    </div>
  );
};

export default Buscador;
